import { render, staticRenderFns } from "./PaymentAme.vue?vue&type=template&id=0d08039b&scoped=true&"
import script from "./PaymentAme.vue?vue&type=script&lang=js&"
export * from "./PaymentAme.vue?vue&type=script&lang=js&"
import style0 from "./PaymentAme.vue?vue&type=style&index=0&id=0d08039b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d08039b",
  null
  
)

export default component.exports